// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-container {
  display: flex;
  justify-content: space-between;
  align-self: center;
  width: 100%;
  height: 25px;
  /* margin-bottom: -18px; */
  padding-bottom: 2px;

  /* background: grey; */
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
}

.button-container button {
  display: flex;
  opacity: 0;
  justify-content: center;

  width: 100%;
  background: white;
  font-size: x-large;

  border: 1px solid grey;
  /* border-radius: 15%; */
  margin: 1px;
  /* box-shadow: 3px 3px 3px #949494; */
  align-items: center;
}

.button-container button:hover {
  background-color: lightgray;
  opacity: 0.4;
  transition: 0.1s linear;
}

.button-container button img:hover {
  color: white;
}

.button-container button img {
  width: 20px;
  height: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/components/elements/carousel-controls/CarouselControls.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;;EAEnB,sBAAsB;EACtB,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,UAAU;EACV,uBAAuB;;EAEvB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;;EAElB,sBAAsB;EACtB,wBAAwB;EACxB,WAAW;EACX,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".button-container {\n  display: flex;\n  justify-content: space-between;\n  align-self: center;\n  width: 100%;\n  height: 25px;\n  /* margin-bottom: -18px; */\n  padding-bottom: 2px;\n\n  /* background: grey; */\n  position: absolute;\n  top: 0;\n  height: 100%;\n  width: 100%;\n}\n\n.button-container button {\n  display: flex;\n  opacity: 0;\n  justify-content: center;\n\n  width: 100%;\n  background: white;\n  font-size: x-large;\n\n  border: 1px solid grey;\n  /* border-radius: 15%; */\n  margin: 1px;\n  /* box-shadow: 3px 3px 3px #949494; */\n  align-items: center;\n}\n\n.button-container button:hover {\n  background-color: lightgray;\n  opacity: 0.4;\n  transition: 0.1s linear;\n}\n\n.button-container button img:hover {\n  color: white;\n}\n\n.button-container button img {\n  width: 20px;\n  height: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
